var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
import { LotteryJackpotDrawStatusEnum } from "../../../../../models/modules/lotteryplatofrm.models";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { I18N } from "aurelia-i18n";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { Router } from "aurelia-router";
import { RequestClient } from '../../../../../services/basics/request-client.service';
import { UserClaimsService } from '../../../../../services/authentication/user-claims.service';
import { QueriesClientService } from '../../../../../services/queries/queries-client.services';
import { DialogServiceConstants } from '../../../../../constants/basics/dialog.constants';
import { RouterConstants } from '../../../../../configuration/router.constants';
import { NumberUtilities } from '../../../../../utilities/number-utilities';
var LotteryJackpotDrawHistoryDialog = /** @class */ (function (_super) {
    __extends(LotteryJackpotDrawHistoryDialog, _super);
    function LotteryJackpotDrawHistoryDialog(notificationService, i18N, userClaimsService, queriesService, dialogClient, router, requestClient) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.notificationService = notificationService;
        _this.userClaimsService = userClaimsService;
        _this.queriesService = queriesService;
        _this.dialogClient = dialogClient;
        _this.router = router;
        _this.requestClient = requestClient;
        _this.lotteryDrawHistoryId = 0;
        _this.mainPicksArray = [];
        return _this;
    }
    LotteryJackpotDrawHistoryDialog.prototype.close = function () {
        this.dialogClient.hide();
    };
    LotteryJackpotDrawHistoryDialog.prototype.saveToNextStatus = function (lotteryJackpotDrawItem) {
        return __awaiter(this, void 0, void 0, function () {
            var nextStatus;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        nextStatus = LotteryJackpotDrawStatusEnum.ActionRequired || LotteryJackpotDrawStatusEnum.ActionRequiredEmailSent;
                        if (!(lotteryJackpotDrawItem.lotteryJackpotDrawStatusId == LotteryJackpotDrawStatusEnum.ActionRequired ||
                            lotteryJackpotDrawItem.lotteryJackpotDrawStatusId == LotteryJackpotDrawStatusEnum.ActionRequiredEmailSent)) return [3 /*break*/, 2];
                        nextStatus = LotteryJackpotDrawStatusEnum.ResultsToReview;
                        lotteryJackpotDrawItem.lotteryJackpotDrawStatusId = nextStatus;
                        return [4 /*yield*/, this.proceedToSave(lotteryJackpotDrawItem, false)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        if (lotteryJackpotDrawItem.lotteryJackpotDrawStatusId == LotteryJackpotDrawStatusEnum.EmailSentToReview ||
                            lotteryJackpotDrawItem.lotteryJackpotDrawStatusId == LotteryJackpotDrawStatusEnum.ResultsToReview) {
                            nextStatus = LotteryJackpotDrawStatusEnum.ResultsReviewed;
                            require("../../dialogs/confirmation-dialog");
                            this.dialogClient.show(DialogServiceConstants.URLs.ConfirmationDialog, {
                                save: function () { return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                lotteryJackpotDrawItem.lotteryJackpotDrawStatusId = nextStatus;
                                                return [4 /*yield*/, this.proceedToSave(lotteryJackpotDrawItem, false)];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); }); }
                            }, true, true);
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LotteryJackpotDrawHistoryDialog.prototype.reject = function (lotteryJackpotDrawItem) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (lotteryJackpotDrawItem.lotteryJackpotDrawStatusId == LotteryJackpotDrawStatusEnum.EmailSentToReview ||
                    lotteryJackpotDrawItem.lotteryJackpotDrawStatusId == LotteryJackpotDrawStatusEnum.ResultsToReview) {
                    require("../../dialogs/confirmation-dialog");
                    this.dialogClient.show(DialogServiceConstants.URLs.ConfirmationDialog, {
                        save: function () { return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        lotteryJackpotDrawItem.lotteryJackpotDrawStatusId = LotteryJackpotDrawStatusEnum.ActionRequired;
                                        return [4 /*yield*/, this.proceedToSave(lotteryJackpotDrawItem, true)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }); }
                    }, true, true);
                }
                return [2 /*return*/];
            });
        });
    };
    LotteryJackpotDrawHistoryDialog.prototype.callBack = function () {
        this.showEditOptions = true;
        this.showJackpotDrawDetails = false;
    };
    LotteryJackpotDrawHistoryDialog.prototype.onActivated = function (lotteryJackpotDrawItem) {
        this.showDrawNumber = false;
        this.showEditOptions = true;
        this.showJackpotDrawDetails = false;
        this.borderStyleForMainPicks = 'none';
        this.drawDate = new Date(lotteryJackpotDrawItem.drawDate).toLocaleDateString('en-gb');
        if ((lotteryJackpotDrawItem.lotteryJackpotDrawStatusId == LotteryJackpotDrawStatusEnum.EmailSentToReview) ||
            (lotteryJackpotDrawItem.lotteryJackpotDrawStatusId == LotteryJackpotDrawStatusEnum.ResultsToReview)) {
            this.jackpotAmt = lotteryJackpotDrawItem.totalJackpot;
            this.drawNumber = lotteryJackpotDrawItem.results;
            this.showEditOptions = false;
            this.showJackpotDrawDetails = true;
            this.showJackpotDrawResultReview = true;
        }
        if (lotteryJackpotDrawItem.results != null) {
            this.mainPicksArray = lotteryJackpotDrawItem.results.split(",")[0].split("-");
            if (this.mainPicksArray.length != lotteryJackpotDrawItem.lottery.drawnNumbers && this.mainPicksArray.length < lotteryJackpotDrawItem.lottery.drawnNumbers) {
                var drawCount = Math.abs(lotteryJackpotDrawItem.lottery.drawnNumbers - this.mainPicksArray.length);
                for (var i = 0; i < drawCount; i++) {
                    this.mainPicksArray.push("");
                }
                lotteryJackpotDrawItem.mainPicks = this.openDialog(this.mainPicksArray, true);
            }
            else if (this.mainPicksArray.length != lotteryJackpotDrawItem.lottery.drawnNumbers && this.mainPicksArray.length > lotteryJackpotDrawItem.lottery.drawnNumbers) {
                this.mainPicksArray = Array.from(Array(lotteryJackpotDrawItem.lottery.drawnNumbers));
                lotteryJackpotDrawItem.mainPicks = this.openDialog(this.mainPicksArray, false);
                this.drawNumberString = lotteryJackpotDrawItem.results.split(",")[0];
                this.showDrawNumber = true;
            }
            else {
                lotteryJackpotDrawItem.mainPicks = this.openDialog(this.mainPicksArray, true);
            }
            //this.bonusBalls = lotteryJackpotDrawItem.results.split(",")[1];
            this.bonusBalls = lotteryJackpotDrawItem.results.split(",").length > 1 ? lotteryJackpotDrawItem.results.split(",")[1] : "";
            for (var i = 2; i < lotteryJackpotDrawItem.results.split(",").length; i++) {
                this.bonusBalls += "," + lotteryJackpotDrawItem.results.split(",")[i];
            }
        }
        else {
            this.mainPicksArray = Array.from(Array(lotteryJackpotDrawItem.lottery.drawnNumbers));
            lotteryJackpotDrawItem.mainPicks = this.openDialog(this.mainPicksArray, false);
            this.bonusBalls = "";
        }
    };
    LotteryJackpotDrawHistoryDialog.prototype.save = function (lotteryJackpotDrawItem, bonusBalls) {
        if (lotteryJackpotDrawItem.mainPicks.length != 0 && this.validateJackpotAmount(lotteryJackpotDrawItem)) {
            if (this.validateBonusDrawNumbers(lotteryJackpotDrawItem, bonusBalls)) {
                if (this.isValueEmpty(lotteryJackpotDrawItem, this.getUniqueMainPicksArray(lotteryJackpotDrawItem))) {
                    var mainPickStrings = lotteryJackpotDrawItem.mainPicks.map(function (item) {
                        return NumberUtilities.pad2(item.drawPickNumber);
                    }).join('-');
                    lotteryJackpotDrawItem.results = mainPickStrings + "," + bonusBalls;
                    this.jackpotAmt = lotteryJackpotDrawItem.totalJackpot;
                    this.drawNumber = lotteryJackpotDrawItem.results;
                    this.showEditOptions = false;
                    this.showJackpotDrawDetails = true;
                }
            }
        }
    };
    LotteryJackpotDrawHistoryDialog.prototype.validateJackpotAmount = function (lotteryJackpotDrawItem) {
        if (lotteryJackpotDrawItem.totalJackpot == null || lotteryJackpotDrawItem.totalJackpot == 0) {
            this.notificationService.show("Validation Error!", "Enter Total Jackpot Amount.", NotificationType.Error);
            return false;
        }
        else if (lotteryJackpotDrawItem.lottery.isCustom) {
            if (lotteryJackpotDrawItem.lottery.minimumJackpot < lotteryJackpotDrawItem.totalJackpot && lotteryJackpotDrawItem.totalJackpot > lotteryJackpotDrawItem.lottery.maximumJackpot) {
                this.notificationService.show("Validation Error!", "Enter lottery Jackpot amount between " + lotteryJackpotDrawItem.lottery.minimumJackpot + " and " + lotteryJackpotDrawItem.lottery.maximumJackpot, NotificationType.Error);
                return false;
            }
        }
        return true;
    };
    LotteryJackpotDrawHistoryDialog.prototype.callSave = function (lotteryjackpotDraw, nextJackpotDrawStatus, isRejected) {
        if (isRejected === void 0) { isRejected = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                require("../../dialogs/confirmation-dialog");
                this.dialogClient.show(DialogServiceConstants.URLs.ConfirmationDialog, {
                    save: function () { return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    lotteryjackpotDraw.lotteryJackpotDrawStatusId = nextJackpotDrawStatus;
                                    return [4 /*yield*/, this.proceedToSave(lotteryjackpotDraw, isRejected)];
                                case 1:
                                    _a.sent();
                                    this.dialogClient.hide();
                                    return [2 /*return*/];
                            }
                        });
                    }); }); },
                    hide: function () { return new Promise(function () {
                        _this.dialogClient.hide();
                    }); }
                });
                return [2 /*return*/];
            });
        });
    };
    LotteryJackpotDrawHistoryDialog.prototype.proceedToSave = function (lotteryjackpotDraw, isRejected) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.requestClient.post("lottery/LotteryJackpotDrawToSave", {}, lotteryjackpotDraw).then(function (result) {
                if (result) {
                    if (isRejected) {
                        _this.notificationService.show("Success", "Rejected Successfully!", NotificationType.Success);
                    }
                    else {
                        _this.notificationService.show("Success", "Updated Successfully!", NotificationType.Success);
                    }
                    location.reload();
                    _this.router.navigateToRoute(RouterConstants.RouteNames.ManageLottery, { id: lotteryjackpotDraw.lotteryId });
                }
                else {
                    _this.notificationService.show("Error", "Update has failed.", NotificationType.Error);
                }
                resolve(result);
            }, function () { });
        });
    };
    LotteryJackpotDrawHistoryDialog.prototype.openDialog = function (mainPicksArray, hasData) {
        var picks = [];
        if (hasData) {
            for (var i = 0; i < mainPicksArray.length; i++) {
                picks.push(mainPicksArray[i] != null ? { drawPickNumber: Number(mainPicksArray[i]) } : { drawPickNumber: null });
            }
            ;
        }
        else {
            for (var i = 0; i < mainPicksArray.length; i++) {
                picks.push({ drawPickNumber: null });
            }
            ;
        }
        return picks;
    };
    LotteryJackpotDrawHistoryDialog.prototype.isValueEmpty = function (lotteryJackpotDrawItem, uniqueMainPicksArray) {
        if (uniqueMainPicksArray.length != lotteryJackpotDrawItem.mainPicks.length) {
            this.borderStyleForMainPicks = '1px solid red';
            this.notificationService.show("Error", "Main picks cannot be empty and Cannot have duplicate numbers.", NotificationType.Error);
            return false;
        }
        for (var i = 0; i < uniqueMainPicksArray.length; i++) {
            if (!(lotteryJackpotDrawItem.lottery.drawMinimumNumber <= uniqueMainPicksArray[i].drawPickNumber && lotteryJackpotDrawItem.lottery.drawMaximumNumber >= uniqueMainPicksArray[i].drawPickNumber)) {
                this.notificationService.show("Validation Error!", "Enter lottery main picks between " + lotteryJackpotDrawItem.lottery.drawMinimumNumber + " and " + lotteryJackpotDrawItem.lottery.drawMaximumNumber, NotificationType.Error);
                this.borderStyleForMainPicks = '1px solid red';
                return false;
            }
        }
        return true;
    };
    LotteryJackpotDrawHistoryDialog.prototype.validateDrawNumber = function (lotteryJackpotDrawItem, onKeyPressEventForDrawPickNumbers) {
        if (!(lotteryJackpotDrawItem.lottery.drawMinimumNumber <= onKeyPressEventForDrawPickNumbers && lotteryJackpotDrawItem.lottery.drawMaximumNumber >= onKeyPressEventForDrawPickNumbers && onKeyPressEventForDrawPickNumbers != null)) {
            this.notificationService.show("Validation Error!", "Enter lottery main picks between " + lotteryJackpotDrawItem.lottery.drawMinimumNumber + " and " + lotteryJackpotDrawItem.lottery.drawMaximumNumber, NotificationType.Error);
            this.borderStyleForMainPicks = '1px solid red';
        }
        else if (this.getUniqueMainPicksArray(lotteryJackpotDrawItem).length != lotteryJackpotDrawItem.mainPicks.length && onKeyPressEventForDrawPickNumbers != null) {
            this.notificationService.show("Validation Error!", "Draw numbers Cannot have duplicate numbers.", NotificationType.Error);
            this.borderStyleForMainPicks = '1px solid red';
        }
        else {
            this.borderStyleForMainPicks = 'none';
        }
    };
    LotteryJackpotDrawHistoryDialog.prototype.validateBonusDrawNumbers = function (lotteryJackpotDrawItem, onKeyPressEventForBonusBall) {
        if (lotteryJackpotDrawItem.lottery.drawnBonusMinimumNumber != null && lotteryJackpotDrawItem.lottery.drawnBonusMaximumNumber != null && lotteryJackpotDrawItem.lottery.drawnBonusNumbers != null && onKeyPressEventForBonusBall == "") {
            this.notificationService.show("Validation Error!", "Enter Lottery Bonus values between " + lotteryJackpotDrawItem.lottery.drawnBonusMinimumNumber + " and " + lotteryJackpotDrawItem.lottery.drawnBonusMaximumNumber, NotificationType.Error);
            this.borderStyleForBonusBall = '1px solid red';
            return false;
        }
        else if (lotteryJackpotDrawItem.lottery.drawnBonusMinimumNumber == null && lotteryJackpotDrawItem.lottery.drawnBonusMaximumNumber == null && lotteryJackpotDrawItem.lottery.drawnBonusNumbers == null && (onKeyPressEventForBonusBall != "")) {
            this.notificationService.show("Validation Error!", "Bonus values are not set in lottery settings. Either this lottery doesn't have a bonus ball or it must be set in the lottery settings.", NotificationType.Error);
            return false;
        }
        else {
            this.borderStyleForBonusBall = 'none';
            return true;
        }
    };
    LotteryJackpotDrawHistoryDialog.prototype.getUniqueMainPicksArray = function (lotteryJackpotDrawItem) {
        var newpick = lotteryJackpotDrawItem.mainPicks
            .map(function (e) { return e['drawPickNumber']; })
            .map(function (e, i, final) { return e != null && final.indexOf(e) === i && i; })
            .filter(function (obj) { return lotteryJackpotDrawItem.mainPicks[obj] != undefined ? (lotteryJackpotDrawItem.mainPicks[obj].drawPickNumber != null ? lotteryJackpotDrawItem.mainPicks[obj] : null) : null; })
            .map(function (e) { return lotteryJackpotDrawItem.mainPicks[e]; });
        return newpick;
    };
    LotteryJackpotDrawHistoryDialog = __decorate([
        transient(),
        autoinject(),
        __metadata("design:paramtypes", [NotificationClientService, I18N, UserClaimsService, QueriesClientService,
            DialogClientService, Router, RequestClient])
    ], LotteryJackpotDrawHistoryDialog);
    return LotteryJackpotDrawHistoryDialog;
}(ChildComponent));
export { LotteryJackpotDrawHistoryDialog };
